import IconBox from 'assets/icons/box-icon.svg';
import IconDiscount from 'assets/icons/discount-icon.svg';
import IconLink from 'assets/icons/link-icon.svg';
import { IAdTileSliderFields } from 'global';
import React from 'react';

type IconNameUnionType = IAdTileSliderFields['icon'];
interface AdTileIconProps {
  iconName: IconNameUnionType;
  svgAttributes?: React.SVGAttributes<SVGElement>;
}

type IconKeys = NonNullable<IconNameUnionType>;

const Icons: {
  [key in IconKeys]: React.FunctionComponent<React.SVGAttributes<SVGElement>>;
} = {
  link: IconLink,
  box: IconBox,
  discount: IconDiscount,
};

/**
 * Render icon defined in AdTileSlider model. If icon name is omitted, null is returned
 */
const CmsIcon: React.FC<AdTileIconProps> = ({ iconName, svgAttributes }) => {
  if (!iconName) {
    return null;
  }

  const Icon = Icons[iconName];

  return <Icon {...svgAttributes} />;
};

export default CmsIcon;
